import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22a80f49"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Spielen")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Informieren")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Aufspüren")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Einstellungen", -1))
const _hoisted_5 = { class: "gained-points-modal-body" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_vue_cookie_comply = _resolveComponent("vue-cookie-comply")!
  const _component_cookie_comply_modal = _resolveComponent("cookie-comply-modal")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      (_ctx.isReady)
        ? (_openBlock(), _createBlock(_component_ion_menu, {
            key: 0,
            side: "end",
            "content-id": "main",
            class: "tt-menu"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.menu")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list, null, {
                    default: _withCtx(() => [
                      (!_ctx.isLoggedIn)
                        ? (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = 
              () => {
                _ctx.router.push('/login');
              }
            )
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, { button: "" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("message.login")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.isLoggedIn && _ctx.appConfig?.useFullUser)
                        ? (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                            key: 1,
                            onClick: _cache[1] || (_cache[1] = 
              () => {
                _ctx.router.push('/register');
              }
            )
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, { button: "" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("message.register")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_menu_toggle, {
                        onClick: _cache[2] || (_cache[2] = 
              () => {
                _ctx.router.push('/tagging');
              }
            )
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            button: "",
                            class: "tt-menu-item"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_menu_toggle, {
                        onClick: _cache[3] || (_cache[3] = 
              () => {
                _ctx.router.push('/explore');
              }
            )
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            button: "",
                            class: "tt-menu-item"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_menu_toggle, {
                        onClick: _cache[4] || (_cache[4] = 
              () => {
                _ctx.router.push('/localinfo');
              }
            )
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            button: "",
                            class: "tt-menu-item"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_menu_toggle, {
                        onClick: _cache[5] || (_cache[5] = 
              () => {
                _ctx.router.push('/top-list');
              }
            )
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { button: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("message.topList")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_menu_toggle, {
                        onClick: _cache[6] || (_cache[6] = 
              () => {
                _ctx.router.push('/about');
              }
            )
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { button: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("message.about")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_menu_toggle, {
                        onClick: _cache[7] || (_cache[7] = 
              () => {
                _ctx.router.push('/impressum');
              }
            )
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { button: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("message.impressum")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_menu_toggle, {
                        onClick: _cache[8] || (_cache[8] = 
              () => {
                _ctx.router.push('/disclaimer');
              }
            )
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { button: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("message.disclaimerShort")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_menu_toggle, {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (
              _ctx.isCookieModalOpen = true
            ))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { button: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("message.disclaimerShort")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_vue_cookie_comply, {
        headerTitle: "Cookie-Einstellungen",
        headerDescription: "Wir verwenden Cookies und ähnliche Technologien, um Inhalte zu personalisieren und ein besseres Erlebnis zu bieten. Sie können sie anpassen, indem Sie auf die Schaltfläche „Einstellungen“ klicken.",
        acceptAllLabel: "Alle akzeptieren",
        preferencesLabel: "Einstellungen",
        rejectAllLabel: "Alles ablehnen",
        preferences: _ctx.preferences,
        onOnAcceptAllCookies: _ctx.onAcceptAllCookies,
        onOnSaveCookiePreferences: _ctx.onSavePreferences,
        showEditButton: true,
        editCookieIconPath: require('../public/assets/img/cookie_edit.svg'),
        greyOutBody: false
      }, {
        "modal-header": _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["preferences", "onOnAcceptAllCookies", "onOnSaveCookiePreferences", "editCookieIconPath"]),
      (_ctx.isCookieModalOpen)
        ? (_openBlock(), _createBlock(_component_ion_modal, { key: 1 }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createVNode(_component_cookie_comply_modal, {
                  preferences: _ctx.preferences,
                  onCookieComplySave: _ctx.onSavePreferences,
                  onCookieComplyClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isCookieModalOpen = false))
                }, {
                  "modal-header": _withCtx(() => [
                    _renderSlot(_ctx.$slots, "modal-header", {}, undefined, true)
                  ]),
                  "modal-body": _withCtx(({ preference, index }) => [
                    _renderSlot(_ctx.$slots, "modal-body", {
                      preference: preference,
                      index: index
                    }, undefined, true)
                  ]),
                  "modal-footer": _withCtx(() => [
                    _renderSlot(_ctx.$slots, "modal-footer", {}, undefined, true)
                  ]),
                  _: 3
                }, 8, ["preferences", "onCookieComplySave"])
              ]))
            ]),
            _: 3
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_modal, {
        "is-open": _ctx.isGainingNewPointsModalOpen,
        class: "gained-points-modal"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('message.gainedpointsPopupTitle')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setIsGainingNewPointsModalOpen(false, 0))),
                        fill: "clear"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.closeOutline,
                            size: "large"
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_ion_icon, { icon: _ctx.trophy }, null, 8, ["icon"]),
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('message.gainedpointsPopupText', {gainedPoints: _ctx.gainedUserPoints})
                }, null, 8, _hoisted_6)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      (_ctx.isReady)
        ? (_openBlock(), _createBlock(_component_ion_router_outlet, {
            key: 2,
            id: "main"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}